import type { ImageEditorOptions } from "@uppy/image-editor"

export const DEFAULT_IMAGE_EDITOR_ACTIONS: ImageEditorOptions["actions"] = {
  revert: true,
  rotate: true,
  granularRotate: false,
  flip: false,
  zoomIn: true,
  zoomOut: true,
  cropSquare: false,
  cropWidescreen: false,
  cropWidescreenVertical: false,
}
